import Layout from '@/views/Layout/index.vue'
const HomePage = () => import('@/views/HomePage/index.vue')
const Home = () => import('@/views/HomePage/Home')
const ChildAgreement = () => import('@/views/HomePage/ChildAgreement')
const PrivateAgreement = () => import('@/views/HomePage/PrivateAgreement')
const UserAgreement = () => import('@/views/HomePage/UserAgreement')
const NoOrg = () => import("@/views/NoOrg");
const ToDoList = () => import("@/views/ToDoList");
const StudentDetail = () => import("@/views/StudentPage/StudentDetail");
const ClueDetail = () => import("@/views/SalePage/ClueDetail");
const DataDetails = () => import("@/views/HomePage/Home/DataDetails")
const CloudDiskStorage = () => import("@/views/HomePage/CloudDiskStorage");
export default {
  path: '/',
  component: Layout,
  name: 'home',
  redirect: '/home',
  children: [
    {
      path: 'home',
      component: HomePage,
      children: [
        {
          path: '',
          component: Home,
        },
        {
          path: 'noorg',
          name: 'noorg',
          component: NoOrg,
        },
        {
          path: 'childagreement',
          component: ChildAgreement,
        },
        {
          path: 'privateagreement',
          component: PrivateAgreement,
        },
        {
          path: 'useragreement',
          component: UserAgreement,
        },
        {
          path: 'todolist',
          component: ToDoList,
        },
        {
          path: 'studentdetail',
          component: StudentDetail,
        },
        {
          path: 'cluedetail',
          component: ClueDetail,
        },
        {
          path: 'datadetails',
          component: DataDetails,
        },
        {
          path: 'cloudDiskStorage',
          component: CloudDiskStorage,
        }
      ]
    }
  ]
}
